import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { UsuarioEsquema } from '../../usuarioEsquema';
import { Usuario } from '../../usuario';

import { ConfInicialesService } from 'src/app/servicios/conf-iniciales.service';
import { Nomtrndistricen } from "../nominterfaces/nomtrndistricen";
@Injectable({
  providedIn: 'root'
})
export class NomtrndistricenService {
  public way: string;

  private _nomdistribucionCC: Nomtrndistricen[];
  public hmpConfiguracion: any[];
  public dblValor: number;
  public total: any;
  public decimalesvalorDet: number;//CDPJ
  public decimalesTOTALDetFacPro: number;

  private _auxsalto: boolean;

  public grids: any[] = [];

  get nomdistribucionCC(): Nomtrndistricen[] {
    return this._nomdistribucionCC;
  }

  set nomdistribucionCC(value: Nomtrndistricen[]) {
    this._nomdistribucionCC = value;
  }
  constructor(
    private http: HttpClient,
    public usuarioEsquema: UsuarioEsquema,
    public usuario: Usuario,
    private confIniciales: ConfInicialesService
  ) {
    this.way = sessionStorage.getItem('way');
  }
  listardatos(strencdistri,stremp): Observable<any[]> {
    return this.http.post<any[]>(this.way + '/nom/nomtrndistricen/2b2e755beeeeda000000000', {
      elementos: {
        encdiscen_codigo: strencdistri,
        emp_codigo: stremp,
        
      }
    }, this.confIniciales.httpOptions());
  }
  calcularTotal() {
    let intIndiceLista = 0;
    let item: Nomtrndistricen;
    let dblTotal = 0;
    for (intIndiceLista = 0; intIndiceLista < this.nomdistribucionCC.length; intIndiceLista++) {
      item = this.nomdistribucionCC[intIndiceLista];
      dblTotal = dblTotal + Number(item.TRNDISCEN_DIAS);
    }
    this.total = dblTotal;
    for (intIndiceLista = 0; intIndiceLista < this.nomdistribucionCC.length; intIndiceLista++) {
      item = this.nomdistribucionCC[intIndiceLista];
      item.TRNDISCEN_DIAS = Number(item.TRNDISCEN_DIAS);
    }
  }
  validarcencodigo(cencodigo) {
    return this.http.post<any[]>(this.way + '/ventas/guiaremision/1f5564d56d8ebf0000000000000', {
      elementos: {
        cen_codigo: cencodigo,
        con_codigo: '01'
      }
    }, this.confIniciales.httpOptions()).toPromise();
  }
  guardardistribucion(item,linea) {
    return this.http.post<any[]>(this.way + '/nom/nomtrndistricen/4afc76faaeeeec0000000000', {
      elementos: {
        p_encdiscen_codigo: item.ENCDISCEN_CODIGO,
        p_emp_codigo: item.EMP_CODIGO,
        p_com_codigo: '01',
        p_cen_codigo: item.CEN_CODIGO,
        p_trndiscen_dias: item.TRNDISCEN_DIAS,
        p_trndiscen_linea: item.TRNDISCEN_LINEA,
        p_detdiscen_linea: linea
      }
    }, this.confIniciales.httpOptions()).toPromise();
  }
  EliminarDistribucionCC(item) : Observable<any> {
    return this.http.post<any[]>(this.way + '/nom/nomtrndistricen/3ab2b4aeaeeeee0000000000', {
      elementos: {
        p_encdiscen_codigo: item.ENCDISCEN_CODIGO,
        p_emp_codigo: item.EMP_CODIGO,
        p_trndiscen_linea: item.TRNDISCEN_LINEA
      }
    }, this.confIniciales.httpOptions());
  }
  getdetroldistri(encdiscen,cencod) {
    return this.http.post<any[]>(this.way + '/nom/nomtrndistricen/41dd6bbbbc55b400000', {
      elementos: {
        p_encdiscen_codigo: encdiscen,
        p_cen_codigo: cencod,
       
      }
    }, this.confIniciales.httpOptions()).toPromise();
  }
}
